import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const { t } = useLanguage();

  return (
    <div className="bg-[#0b131e] min-h-screen flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="max-w-md w-full rounded-lg border border-white/10 bg-[#0f1b29] p-10 text-center space-y-4">
        <div className="flex justify-center">
          <XCircle className="text-white/40" size={40} />
        </div>
        <h1 className="font-serif-didot text-2xl text-white" data-testid="payment-cancel-title">{t.payment.cancelTitle}</h1>
        <p className="text-sm text-white/60" data-testid="payment-cancel-text">{t.payment.cancelText}</p>
        <Link
          to="/"
          data-testid="cancel-back-home-link"
          className="inline-block mt-4 px-6 py-3 border border-[#E2C079] text-[#E2C079] text-xs font-mono-code uppercase tracking-widest hover:bg-[#E2C079] hover:text-[#0b131e] transition-colors"
        >
          {t.payment.back}
        </Link>
      </div>
    </div>
  );
}
